export enum AllergyOptionsEnum {
	UNDEFINED = 0,
	YES = 1,
	NO = 2,
	UNABLE_TO_OBTAIN = 3,
}
